/* eslint-disable react-refresh/only-export-components */
import { Tooltip } from "antd";
import { memo, type ReactNode } from "react";

const STATUS = {
  ACTIVE: "green",
  SUSPENDED: "orange",
  INACTIVE: "red",
  CREATED: "green",
} as const;

export interface CustomBadgeProps {
  status?: keyof typeof STATUS;
  title?: ReactNode;
}

const CustomBadge = ({ status, title }: CustomBadgeProps) => (
  <div className="flex items-center gap-1 hover:cursor-pointer">
    <Tooltip title={status} placement="top">
      <div
        className="w-3 h-3 rounded-full"
        style={{ backgroundColor: status ? STATUS[status] : undefined }}
      />
    </Tooltip>
    <Tooltip title={title} placement="top">
      <p className="font-normal text-left capitalize truncate text-lightBlack">
        {title}
      </p>
    </Tooltip>
  </div>
);

export default memo(CustomBadge);
